/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ fixedActionsSection)
});

;// external "@babel/runtime/helpers/jsx"
const jsx_namespaceObject = require("@babel/runtime/helpers/jsx");
var jsx_default = /*#__PURE__*/__webpack_require__.n(jsx_namespaceObject);
;// external "@babel/runtime/helpers/objectSpread2"
const objectSpread2_namespaceObject = require("@babel/runtime/helpers/objectSpread2");
var objectSpread2_default = /*#__PURE__*/__webpack_require__.n(objectSpread2_namespaceObject);
;// external "@babel/runtime/helpers/slicedToArray"
const slicedToArray_namespaceObject = require("@babel/runtime/helpers/slicedToArray");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_namespaceObject);
;// external "core-js/modules/es.number.is-nan.js"
const es_number_is_nan_js_namespaceObject = require("core-js/modules/es.number.is-nan.js");
;// external "core-js/modules/es.regexp.sticky.js"
const es_regexp_sticky_js_namespaceObject = require("core-js/modules/es.regexp.sticky.js");
;// external "react"
const external_react_namespaceObject = require("react");
;// external "prop-types"
const external_prop_types_namespaceObject = require("prop-types");
;// external "classnames"
const external_classnames_namespaceObject = require("classnames");
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_namespaceObject);
;// external "@pog-ui-landings-library/framework"
const framework_namespaceObject = require("@pog-ui-landings-library/framework");
;// external "@andes-landings/actions"
const actions_namespaceObject = require("@andes-landings/actions");
;// ./utils/src/throttle.js
/* istanbul ignore file */

var throttle = function throttle(fn, wait) {
  var timerId = null;
  return function () {
    if (timerId === null) {
      fn.apply(void 0, arguments);
      timerId = setTimeout(function () {
        timerId = null;
      }, wait);
    }
  };
};
/* harmony default export */ const src_throttle = (throttle);
;// external "@babel/runtime/helpers/defineProperty"
const defineProperty_namespaceObject = require("@babel/runtime/helpers/defineProperty");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_namespaceObject);
;// external "core-js/modules/es.array.for-each.js"
const es_array_for_each_js_namespaceObject = require("core-js/modules/es.array.for-each.js");
;// external "core-js/modules/es.array.reduce.js"
const es_array_reduce_js_namespaceObject = require("core-js/modules/es.array.reduce.js");
;// external "core-js/modules/es.object.keys.js"
const es_object_keys_js_namespaceObject = require("core-js/modules/es.object.keys.js");
;// external "core-js/modules/es.object.to-string.js"
const es_object_to_string_js_namespaceObject = require("core-js/modules/es.object.to-string.js");
;// external "core-js/modules/esnext.iterator.constructor.js"
const esnext_iterator_constructor_js_namespaceObject = require("core-js/modules/esnext.iterator.constructor.js");
;// external "core-js/modules/esnext.iterator.for-each.js"
const esnext_iterator_for_each_js_namespaceObject = require("core-js/modules/esnext.iterator.for-each.js");
;// external "core-js/modules/esnext.iterator.reduce.js"
const esnext_iterator_reduce_js_namespaceObject = require("core-js/modules/esnext.iterator.reduce.js");
;// external "core-js/modules/web.dom-collections.for-each.js"
const web_dom_collections_for_each_js_namespaceObject = require("core-js/modules/web.dom-collections.for-each.js");
;// ./utils/src/dataAttributesHelpers.js










var normalizeDataAttributesConfig = function normalizeDataAttributesConfig(config) {
  if (!config) {
    return null;
  }
  if (!config.dataAttributes) {
    return objectSpread2_default()({}, config);
  }
  var clone = objectSpread2_default()({}, config);
  var dataAttributes = clone.dataAttributes;
  if (dataAttributes) {
    var dataProps = Object.keys(dataAttributes).reduce(function (accumulator, key) {
      return objectSpread2_default()(objectSpread2_default()({}, accumulator), {}, defineProperty_default()({}, "data-".concat(key), dataAttributes[key]));
    }, {});
    var normalizedConfig = objectSpread2_default()(objectSpread2_default()({}, clone), dataProps);
    delete normalizedConfig.dataAttributes;
    return normalizedConfig;
  }
  return clone;
};
var bulkNormalizeDataAttributesConfig = function bulkNormalizeDataAttributesConfig(obj) {
  var normalizedConfigs;
  for (var _len = arguments.length, configs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    configs[_key - 1] = arguments[_key];
  }
  configs.forEach(function (config) {
    normalizedConfigs = _objectSpread(_objectSpread({}, normalizedConfigs), {}, _defineProperty({}, config, obj ? normalizeDataAttributesConfig(obj[config]) : null));
  });
  return normalizedConfigs;
};
;// external "core-js/modules/es.number.constructor.js"
const es_number_constructor_js_namespaceObject = require("core-js/modules/es.number.constructor.js");
;// ./components/hooks/useOnScreen.js


var useOnScreen = function useOnScreen(ref) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var _useState = (0,external_react_namespaceObject.useState)(false),
    _useState2 = slicedToArray_default()(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var observer = (0,external_react_namespaceObject.useMemo)(function () {
    if (typeof IntersectionObserver !== 'function') {
      setIsVisible(false);
      return null;
    }
    return new IntersectionObserver(function (_ref) {
      var _ref2 = slicedToArray_default()(_ref, 1),
        entry = _ref2[0];
      setIsVisible(entry.isIntersecting);
    }, {
      threshold: threshold
    });
  }, [ref]);
  (0,external_react_namespaceObject.useEffect)(function () {
    if (observer) {
      if (ref !== null && ref !== void 0 && ref.current) {
        observer.observe(ref.current);
      }
    }
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);
  return {
    isVisible: isVisible,
    observer: observer
  };
};
;// ./components/hooks/useTrackShow.js





var useTrackShow = function useTrackShow(refModule, tracking, sectionMetadata) {
  var requireDispatchCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var _ref = tracking || {},
    onShow = _ref.onShow;
  var refElement = onShow !== null && onShow !== void 0 && onShow.enabled ? refModule : null;
  var customThreshold = Number(onShow === null || onShow === void 0 ? void 0 : onShow.threshold);
  var threshold = 0.9;
  if (!Number.isNaN(customThreshold) && customThreshold >= 0.0 && customThreshold <= 1.0) {
    threshold = customThreshold;
  }
  var trackingHandler = (0,framework_namespaceObject.useTracking)();
  var trackShow = (0,framework_namespaceObject.getShowTrackingFn)(trackingHandler);
  var _useOnScreen = useOnScreen(refElement, threshold),
    isVisible = _useOnScreen.isVisible,
    observer = _useOnScreen.observer;
  (0,external_react_namespaceObject.useEffect)(function () {
    if (isVisible) {
      trackShow(sectionMetadata);
      if (observer) {
        observer.disconnect();
      }
    }
  }, [isVisible]);
  if (requireDispatchCall) {
    var sendTrackShow = function sendTrackShow(data) {
      trackShow(data);
    };
    return {
      isVisible: isVisible,
      sendTrackShow: sendTrackShow
    };
  }
  return {
    isVisible: isVisible
  };
};
/* harmony default export */ const hooks_useTrackShow = (useTrackShow);
;// ./components/sections/fixedActionsSection/src/constants/fixedActionsProps.js
var COOKIE_CLASSNAME = '.cookie-consent-banner-opt-out';
var CONTAINER_SELECTOR = 'body';
;// external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// ./components/sections/fixedActionsSection/src/FixedActionsSection.js





/**
 * Component dependencies
 */






// utils





var namespace = 'pog-ui-fixed-actions-section';
var BUTTON_PRIMARY = framework_namespaceObject.TRACKING_TRIGGERS.BUTTON_PRIMARY,
  BUTTON_ALTERNATIVE = framework_namespaceObject.TRACKING_TRIGGERS.BUTTON_ALTERNATIVE;

/**
 * FixedActionsSection
 */

var FixedActionsSection = function FixedActionsSection(_ref) {
  var className = _ref.className,
    id = _ref.id,
    isMobile = _ref.isMobile,
    isWebView = _ref.isWebView,
    mainButton = _ref.mainButton,
    alternativeButton = _ref.alternativeButton,
    sticky = _ref.sticky,
    tracking = _ref.tracking,
    sectionMetadata = _ref.sectionMetadata;
  var _useState = (0,external_react_namespaceObject.useState)(false),
    _useState2 = slicedToArray_default()(_useState, 2),
    isSticky = _useState2[0],
    setIsSticky = _useState2[1];
  var _useState3 = (0,external_react_namespaceObject.useState)(false),
    _useState4 = slicedToArray_default()(_useState3, 2),
    firstRunCheck = _useState4[0],
    setFirstRunCheck = _useState4[1];
  var containerRef = (0,external_react_namespaceObject.useRef)();
  var trackingHandler = (0,framework_namespaceObject.useTracking)();
  var trackClick = (0,framework_namespaceObject.getDefaultEventTrackingFn)(trackingHandler);
  hooks_useTrackShow(containerRef, tracking, sectionMetadata);
  var normalizedMainButton = normalizeDataAttributesConfig(mainButton);
  var normalizedAlternativeButton = normalizeDataAttributesConfig(alternativeButton);
  var getButtonConfig = function getButtonConfig(button, type) {
    if (!(button !== null && button !== void 0 && button.title)) {
      return null;
    }
    var buttonProps = objectSpread2_default()({}, button);
    var trackdata = (0,framework_namespaceObject.buildTracks)(button === null || button === void 0 ? void 0 : button.trackdata, type, sectionMetadata);
    if (button !== null && button !== void 0 && button.href && isWebView) {
      buttonProps = objectSpread2_default()(objectSpread2_default()({}, buttonProps), {}, {
        href: button.webviewHref || button.href
      });
    }
    buttonProps = objectSpread2_default()(objectSpread2_default()({}, buttonProps), {}, {
      onClick: function onClick(ev) {
        trackClick(ev, trackdata);
      }
    });
    return buttonProps;
  };
  var checkSticky = function checkSticky() {
    setFirstRunCheck(true);
    var pageOffset = (document.scrollingElement || document.documentElement).scrollTop;
    var threshold = 0;
    var newIsSticky = isSticky;
    try {
      var elementSelector = sticky.elementSelector,
        _sticky$offset = sticky.offset,
        offset = _sticky$offset === void 0 ? 0 : _sticky$offset;
      if (elementSelector && !Number.isNaN(offset)) {
        var element = document.querySelector(elementSelector);
        threshold = element.offsetTop + offset;
      }
    } catch (err) {
      threshold = 0;
    }
    newIsSticky = pageOffset >= threshold;
    if (isSticky === newIsSticky) {
      return;
    }
    setIsSticky(newIsSticky);
  };
  var addSpacer = function addSpacer() {
    if (containerRef.current) {
      var spacerNamespace = "".concat(namespace, "--spacer");
      var hasSpacer = document.querySelector(spacerNamespace);
      if (!hasSpacer) {
        var currentHeight = containerRef.current.offsetHeight;
        var fixedValueSpacing = document.createElement('div');
        fixedValueSpacing.classList.add(spacerNamespace);
        fixedValueSpacing.style.height = "".concat(currentHeight, "px");
        var container = document.querySelector(CONTAINER_SELECTOR);
        container.append(fixedValueSpacing);
      }
    }
  };
  var handleScroll = src_throttle(checkSticky, 20);
  (0,external_react_namespaceObject.useEffect)(function () {
    var _document$querySelect;
    var config = {
      attributes: false,
      childList: true,
      characterData: false,
      subtree: true
    };
    var target = (_document$querySelect = document.querySelector(COOKIE_CLASSNAME)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.parentElement;
    if (target) {
      var observer = new MutationObserver(function () {
        var hasCookieBanner = document.querySelector(COOKIE_CLASSNAME);
        if (!hasCookieBanner) {
          document.getElementsByClassName(namespace)[0].style.bottom = '0px';
          observer.disconnect();
        }
      });
      observer.observe(target, config);
    }
  }, []);
  (0,external_react_namespaceObject.useEffect)(function () {
    if (isMobile) {
      var cookieBanner = document.querySelector(COOKIE_CLASSNAME);
      if (cookieBanner) {
        var cookieBannerHeight = cookieBanner.offsetHeight;
        document.getElementsByClassName(namespace)[0].style.bottom = "".concat(cookieBannerHeight, "px");
      }
      addSpacer();
      window.addEventListener('scroll', handleScroll, {
        passive: true
      });
      if (!firstRunCheck) {
        checkSticky();
      }
    }
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobile, isSticky, handleScroll, firstRunCheck]);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    id: id,
    ref: containerRef,
    className: external_classnames_default()(namespace, className, isMobile ? "".concat(namespace, "--mobile") : "".concat(namespace, "--desktop"), isMobile && isSticky ? "".concat(namespace, "--fixed") : "".concat(namespace, "--hidden")),
    "data-testid": "fixedActions",
    children: /*#__PURE__*/jsx_default()("div", {
      className: "".concat(namespace, "__actions")
    }, void 0, ((mainButton === null || mainButton === void 0 ? void 0 : mainButton.title) || (alternativeButton === null || alternativeButton === void 0 ? void 0 : alternativeButton.title)) && /*#__PURE__*/jsx_default()(actions_namespaceObject.Actions, {
      primary: getButtonConfig(normalizedMainButton, BUTTON_PRIMARY),
      secondary: getButtonConfig(normalizedAlternativeButton, BUTTON_ALTERNATIVE)
    }))
  });
};

/**
 * Prop types
 */

FixedActionsSection.defaultProps = {
  className: '',
  id: null,
  isMobile: false,
  isWebView: false,
  mainButton: null,
  alternativeButton: null,
  sticky: null,
  tracking: null
};

/**
 * Export component
 */
/* harmony default export */ const src_FixedActionsSection = (FixedActionsSection);
;// ./packages/fixedActionsSection/src/FixedActionsSection.js

/* harmony default export */ const fixedActionsSection_src_FixedActionsSection = (src_FixedActionsSection);
;// ./packages/fixedActionsSection/index.js
/**
 * Export Component
 */

/* harmony default export */ const fixedActionsSection = (fixedActionsSection_src_FixedActionsSection);
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=index.production.js.map